import { AppointmentControllerApi, AppointmentStatusChange } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useUpdateAppointmentStatus = () =>
  useMutationWithLoading(
    async (params: AppointmentStatusChange & { xTENANTID?: string }) =>
      new AppointmentControllerApi(getConfigObject()).updateAppointmentStatus(
        params,
        params.xTENANTID
      )
  );
